<template>
  <div class="step1">
    <PlateTitle title="投保信息">
      <template #tip>
        请投标人认真如实填写
      </template>
    </PlateTitle>
    <a-spin :spinning="spinning">
      <a-form
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 10 }"
      >
        <a-form-item
          label="投标人名称"
          has-feedback
        >
          <span>{{ dataSourceInfo.name }}</span>
        </a-form-item>
        <a-form-item
          label="投标人统一社会信用代码"
          has-feedback
        >
          <span>{{ dataSourceInfo.creditCode }}</span>
        </a-form-item>
        <a-form-item
          label="标段名称"
          has-feedback
        >
          <span>{{ dataSourceInfo.sectionName }}</span>
        </a-form-item>
        <a-form-item
          label="标段编号"
          has-feedback
        >
          <span>{{ dataSourceInfo.sectionCode }}</span>
        </a-form-item>
        <a-form-item
          label="担保金额"
          has-feedback
        >
          <span>{{ dataSourceInfo.sumAmount }} 元</span>
        </a-form-item>
        <a-form-item
          label="招标人名称"
          has-feedback
        >
          <span>{{ dataSourceInfo.tendereeName }}</span>
        </a-form-item>
        <a-form-item
          label="招标人统一社会信用代码"
          has-feedback
        >
          <span>{{ dataSourceInfo.tendereeCreditCode }}</span>
        </a-form-item>
      </a-form>

      <a-form
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 8 }"
      >
        <!-- &&dataSourceInfo.channelCode !== 'hainan' -->
        <div v-if="showInvoiceFields">
          <PlateTitle title="开票申请" />
          <a-form-item
            label="选择开票类型"
            has-feedback
          >
            <a-select
              v-decorator="[
                'invoiceType',
                { rules: [{ required: true, message: '请选择开票类型' }] }
              ]"
              placeholder="请选择开票类型"
              style="width: 280px"
              @change="handleChane"
            >
              <a-select-option
                v-for="(item, index) in typeArray"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="发票抬头"
            has-feedback
          >
            <a-input
              v-decorator="[
                'invoiceHead',
                { rules: [{ required: true, message: '请输入发票抬头' }] }
              ]"
              placeholder="请输入发票抬头"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item
            label="纳税人识别号"
            has-feedback
          >
            <a-input
              v-decorator="[
                'invoiceCuscCode',
                { rules: [{ required: true, message: '请输入纳税人识别号' }] }
              ]"
              placeholder="请输入纳税人识别号"
              style="width: 280px"
            />
          </a-form-item>
          <template v-if="radioNum == 3">
            <a-form-item
              label="企业注册地址"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'addInfo',
                  { rules: [{ required: true, message: '请输入企业注册地址' }] }
                ]"
                placeholder="请输入企业注册地址"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="联系电话"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'phoneNo',
                  { rules: [{ required: true, message: '请输入联系电话' }] }
                ]"
                placeholder="请输入联系电话"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="开户行"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'bankInfo',
                  { rules: [{ required: true, message: '请输入开户行' }] }
                ]"
                placeholder="请输入开户行"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="开户账号"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'bankAcc',
                  { rules: [{ required: true, message: '请输入开户账号' }] }
                ]"
                placeholder="请输入开户账号"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="收件人"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'addressee',
                  { rules: [{ required: true, message: '请输入收件人' }] }
                ]"
                placeholder="请输入收件人"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="收件人手机号"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'addresseePhone',
                  { rules: [{ required: true, message: '请输入收件人手机号' }] }
                ]"
                placeholder="请输入收件人手机号"
                style="width: 280px"
              />
            </a-form-item>
            <a-form-item
              label="收件地址"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'address',
                  { rules: [{ required: true, message: '请输入收件地址' }] }
                ]"
                placeholder="请输入收件地址"
                style="width: 280px"
              />
            </a-form-item>
          </template>
          <template v-else>
            <a-form-item
              label="电子邮箱"
              has-feedback
            >
              <a-input
                v-decorator="[
                  'invoiceEmail',
                  { rules: [{ required: true, validator: getEmail }] }
                ]"
                placeholder="电子邮箱"
                style="width: 280px"
              />
            </a-form-item>
          </template>
        </div>

        <PlateTitle title="投保信息" />

        <div v-if="showTabbedPartnerList">
          <a-form-item
            label="出函机构"
            has-feedback
            class="img_logo"
          >
            <div class="select">
              <!--  -->
              <div
                class="list"
                v-if="dataSourceInfo.channelCode == 'qianshanHuaShang'||dataSourceInfo.channelCode == 'anqingHuaShang'||dataSourceInfo.channelCode == 'wangjiang'||dataSourceInfo.channelCode == 'taihu'||dataSourceInfo.channelCode == 'yuexi'||dataSourceInfo.channelCode == 'zhanjiang1'|dataSourceInfo.channelCode == 'foshan'|dataSourceInfo.channelCode == 'zhongliang'|dataSourceInfo.channelCode == 'guangzheng'|dataSourceInfo.channelCode == 'qinghai'|dataSourceInfo.channelCode == 'hetian'|dataSourceInfo.channelCode == 'shuitou'||dataSourceInfo.channelCode == 'beidahuang'||dataSourceInfo.channelCode == 'zxjhzhc'||dataSourceInfo.channelCode == 'zxjzhdb'||dataSourceInfo.channelCode == 'zxjhhdb'"
              >
                <span
                  class="dbSpan"
                  v-for="(item, index) in dbList"
                  :key="index"
                  @click="activeIndex = index;dbListClick(item.partnerCode)"
                >
                  <!-- <div v-if="index === 0">{{item}}</div> -->
                  <!-- <img  class="imgs" :src="item.logoPath" /> -->
                  <img
                    class="imgs"
                    :src="'data:image/png;base64,'+item.logPathBase64"
                  >
                  <img
                    v-if="activeIndex === index"
                    class="suc"
                    src="../../../assets/image/icon-cg.png"
                  >
                </span>
              </div>
              <!--  -->
              <a-tabs
                v-model="activeKey"
                @change="changeTab(activeKey)"
                v-else
              >
                <a-tab-pane
                  key="3"
                  tab="担保公司"
                >
                  <div
                    class="list"
                    v-if="dataSourceInfo.channelCode == 'hcjs'"
                  >
                    <span
                      class="dbSpan dbSpanhcjs"
                      v-for="(item, index) in dbList"
                      :key="index"
                      @click="activeIndex = index;dbListClick(item.partnerCode)"
                    >
                      <!-- <div v-if="index === 0">{{item}}</div> -->
                      <!-- <img  class="imgs" :src="item.logoPath" /> -->
                      <img
                        class="imgs"
                        :src="'data:image/png;base64,'+item.logPathBase64"
                      >
                      <img
                        v-if="activeIndex === index"
                        class="suc"
                        src="../../../assets/image/icon-cg.png"
                      >
                      <span class="dbSpanhcjsP">
                        <span class="dbSpanhcjsPone"><span class="tipA" />出函时间：3秒内</span>
                        <span class="dbSpanhcjsPone"><span class="tipA" />费率：{{ item.rate }}%（最低{{ item.sumPremium }}元）</span>
                      </span>
                    </span>
                  </div>
                  <div
                    class="list"
                    v-else
                  >
                    <span
                      class="dbSpan"
                      v-for="(item, index) in dbList"
                      :key="index"
                      @click="activeIndex = index;dbListClick(item.partnerCode)"
                    >
                      <!-- <div v-if="index === 0">{{item}}</div> -->
                      <!-- <img  class="imgs" :src="item.logoPath" /> -->
                      <img
                        class="imgs"
                        :src="'data:image/png;base64,'+item.logPathBase64"
                      >
                      <img
                        v-if="activeIndex === index"
                        class="suc"
                        src="../../../assets/image/icon-cg.png"
                      >
                    </span>
                  </div>
                </a-tab-pane>

                <a-tab-pane
                  key="2"
                  tab="保险公司"
                  force-render
                  v-if="dataSourceInfo.channelCode !== 'hcjs'"
                >
                  <div class="list">
                    <span
                      class="mb10"
                      v-for="(item, index) in bxList"
                      :key="index"
                      @click="activeIndex = index;dbListClick(item.partnerCode)"
                    >
                      <!-- <img :src="item.logoPath" />  -->
                      <img :src="'data:image/png;base64,'+item.logPathBase64">
                      <img
                        v-if="activeIndex === index"
                        class="suc"
                        src="../../../assets/image/icon-cg.png"
                      >
                    </span>
                  </div>
                </a-tab-pane>

                <a-tab-pane
                  key="1"
                  tab="银行"
                  v-if="dataSourceInfo.channelCode !== 'hcjs'"
                >
                  <div class="list">
                    <span
                      v-for="(item, index) in bankList"
                      :key="index"
                      @click="activeIndex = index;dbListClick(item.partnerCode)"
                    >
                      <!-- <img :src="item.logoPath" />  -->
                      <img :src="'data:image/png;base64,'+item.logPathBase64">
                      <img
                        v-if="activeIndex === index"
                        class="suc"
                        src="../../../assets/image/icon-cg.png"
                      >
                    </span>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </div>
          </a-form-item>
          <a-form-item
            label=""
            has-feedback
            class="hide"
          >
            <a-input
              v-decorator="[
                'partnerCode',
                { rules: [{ required: true, message: '请输入' }] }
              ]"
              placeholder="请输入"
              style="width: 280px"
            />
          </a-form-item>
        </div>
        <div v-else>
          <a-form-item
            label="出函机构"
            has-feedback
            class="img_logo"
          >
            <div
              class="img_list"
              v-decorator="[
                'partnerCode',
                {
                  rules: [
                    {
                      required: dataSourceInfo.partnerCode ? false : true,
                      message: '请点击选择'
                    }
                  ]
                }
              ]"
            >
              <template v-for="(item, index) in logoArray">
                <div
                  :key="item.partnerCode || index"
                  :id="dataSourceInfo.partnerCode ? 'cur' : 'no'"
                  class="box"
                  @click="activeIndex = index;handleClick(item)"
                >
                  <!-- <div>{{ item.partnerName }}</div> -->
                  <div
                    class="logo_box"
                    :id="item.isTrue ? 'cur_i' : ''"
                  >
                    <img
                      :src="item.logoPath"
                      alt=""
                    >
                    <img
                      v-if="activeIndex === index"
                      class="suc"
                      src="../../../assets/image/icon-cg.png"
                    >
                  </div>
                </div>
              </template>
            </div>
          </a-form-item>
        </div>
        <a-form-item
          label="保费"
          class="img_logo"
        >
          <div class="money">
            {{ dataSourceInfo.sumPremium }}元
          </div>
        </a-form-item>
        <!-- <a-form-item label="保函有效期" has-feedback>
          <a-select
            v-decorator="[
              'period',
              { rules: [{ required: true, message: '请选择保函有效期' }] }
            ]"
            placeholder="请选择保函有效期"
            style="width: 280px"
          >
            <a-select-option
              v-for="(item, index) in timeArray"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <div v-if="showBasicAccountFields">
          <a-form-item
            label="基本户户名"
            has-feedback
          >
            <a-input
              v-decorator="[
                'basicAccountName',
                { rules: [{ required: true, validator: basicAccountName }] }
              ]"
              placeholder="请输入基本户户名"
              style="width: 280px"
            />
          </a-form-item>
          <a-form-item
            label="基本户银行账号"
            has-feedback
            class="basicAccountNo"
          >
            <a-input
              v-decorator="[
                'basicAccountNo',
                { rules: [{ required: true, validator: basicAccountNo }] }
              ]"
              placeholder="请输入基本户银行账号"
              style="width: 280px"
            />
            <span
              v-if="showBasicAccountTip"
              class="tip"
            >(务必正确填写基本户银行账号，填写错误会造成废标)</span>
          </a-form-item>
          <a-form-item
            v-if="isHetianChannel"
            label="基本户统一社会信用代码"
            has-feedback
          >
            <a-input
              v-decorator="[
                'basicAccountCode',
                { rules: [{ required: true, validator: basicAccountCode }] }
              ]"
              placeholder="请输入基本户统一社会信用代码"
              style="width: 280px"
            />
          </a-form-item>
        </div>
        <a-form-item
          label="经办人"
          has-feedback
        >
          <a-input
            v-decorator="[
              'responsiblePersonName',
              { rules: [{ required: true, validator: responsiblePersonName }] }
            ]"
            placeholder="请输入经办人"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item
          label="经办人联系方式"
          has-feedback
        >
          <a-input
            v-decorator="[
              'mobile',
              { rules: [{ required: true, validator: compareToFirstPhone }] }
            ]"
            placeholder="请输入经办人联系方式"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item
          label="验证码"
          class="code"
          v-show="false"
        >
          <a-input
            v-decorator="[
              'code',
              { rules: [{ required: true, validator: compareToFirstCode }] }
            ]"
            placeholder="请输入验证码"
            style="width: 280px"
          />
          <img
            :src="codeImg"
            alt=""
            @click="code"
          >
        </a-form-item>
        <!-- <a-form-item label="短信验证码" class="code">
          <a-input
            v-decorator="[
              'phCode',
              { rules: [{ required: true, validator: compareToFirstPhcode }] }
            ]"
            placeholder="请输入短信验证码"
            style="width: 280px"
          />
          <a v-if="isTime" @click="phoneCode">获取验证码</a>
          <span v-else>{{ time }}s重新获取</span>
        </a-form-item> -->

        <a-form-item
          label="工号"
          has-feedback
          v-if="showInvitationCode"
        >
          <a-input
            maxlength="20"
            v-decorator="[
              'invitationCode',
              { rules: [{ required: false, max:20,message:'最多长度为20'}] }
            ]"
            placeholder="请输入工号"
            style="width: 280px"
          />
        </a-form-item>

        <a-form-item v-if="step === 0">
          <!-- <a-checkbox
            v-decorator="[
              'checked',
              { rules: [{ validator: compareToFirstChecked }] }
            ]"
            style="width: 500px;"
          >
            已阅读并同意
            <a
              v-for="(item, index) in readDocMap"
              :key="index"
              class="hrefa"
              :href="item"
              >{{ index }}</a
            >
          </a-checkbox> -->
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import {
  code,
  phoneCode,
  getList,
  getChannelInfo,
  getDictInfo,
  getLastAccount,
} from '@/api/insure.js';

const HEILONGJIANG_CHANNELS = [ 'heilongjiang' ];
// 命中以下合作机构的订单在投保页显示「工号」字段（invitationCode），其余合作机构隐藏
const INVITATION_CODE_SHOW_PARTNERS = [ 'HLJ_ZYHX', 'HLJ_ZRDB' ];
const BASIC_ACCOUNT_CHANNELS = [
  'nmgzzq',
  'hainan',
  'anqin',
  'yuexi',
  'zhanjiang1',
  'foshan',
  'zhongliang',
  'qinghai',
  'guangzheng',
  'zxjhzhc',
  'zxjzhdb',
  'zxjhhdb',
  'hetian',
  'shuitou',
  'beidahuang',
  'qianshan',
  'nmgzzqXam',
  'wangjiang',
  'qianshanHuaShang',
  'anqingHuaShang',
  'taihu',
  ...HEILONGJIANG_CHANNELS,
];
const HIDDEN_BASIC_ACCOUNT_TIP_CHANNELS = [
  'foshan',
  'qinghai',
  'beidahuang',
  ...HEILONGJIANG_CHANNELS,
];
const HIDDEN_INVOICE_CHANNELS = [
  'nmgzzq',
  'zhongliang',
  'guangzheng',
  'qinghai',
  'qianshan',
  'hetian',
  'shuitou',
  'beidahuang',
  'zxjhzhc',
  'zxjzhdb',
  'zxjhhdb',
  'nmgzzqXam',
];
const SIMPLE_PARTNER_CHANNELS = [
  'hainan',
  'nmgzzq',
  'anqin',
  'qianshan',
  'nmgzzqXam',
  ...HEILONGJIANG_CHANNELS,
];
const INIT_BASIC_ACCOUNT_CHANNELS = [
  'nmgzzq',
  'hainan',
  'anqin',
  'hetian',
  'qianshan',
  'beidahuang',
  'nmgzzqXam',
  ...HEILONGJIANG_CHANNELS,
];

export default {
  name: 'Step1',
  components: {
    PlateTitle,
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    spinning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeKey: '3',
      activeIndex: 0,
      uuid: '',
      selectedPartnerCode: '', // 当前选中的出函机构编码，用于工号字段显隐判断
      codeImg: '',
      isTime: true,
      time: 60,
      form: this.$form.createForm(this, { name: 'loginForm' }),
      orderNo: '',
      rules: {},
      readDocMap: '', // 已阅读并同意文件
      certTypeList: [], // 身份证件类型
      typeArray: [], // 选择开票类型
      timeArray: [],
      logoArray: [],
      radioNum: null,
      bankList: [
        // require("../../../assets/info/b1.png"),
        // require("../../../assets/info/b2.png"),
        // require("../../../assets/info/b3.png"),
        // require("../../../assets/info/b4.png"),
        // require("../../../assets/info/b5.png"),
        // require("../../../assets/info/b6.png"),
        // require("../../../assets/info/b7.png"),
        // require("../../../assets/info/b8.jpg")
      ],
      bxList: [
        // require("../../../assets/info/bx1.jpg"),
        // require("../../../assets/info/bx2.jpg"),
        // require("../../../assets/info/bx3.jpg"),
        // require("../../../assets/info/bx4.jpg"),
        // require("../../../assets/info/bx5.jpg")
      ],
      dbList: [
        // '陕西文化产业融资担保',
        // require("../../../assets/info/db1.jpg")
      ],
    };
  },
  computed: {
    dataSourceInfo() {
      console.log(this.dataSource, 99);
      return this.dataSource;
    },
    channelCode() {
      return this.dataSourceInfo.channelCode;
    },
    isHeilongjiangChannel() {
      return HEILONGJIANG_CHANNELS.includes(this.channelCode);
    },
    showInvitationCode() {
      // 黑龙江交易中心：选中中亿合信（HLJ_ZYHX）或智融融资担保（HLJ_ZRDB）显示工号，其余出函机构隐藏
      return INVITATION_CODE_SHOW_PARTNERS.includes(
        this.selectedPartnerCode || this.dataSourceInfo.partnerCode
      );
    },
    isHetianChannel() {
      return this.channelCode === 'hetian';
    },
    isZxjHzhcChannel() {
      return this.channelCode === 'zxjhzhc';
    },
    isZxjZhdbChannel() {
      return this.channelCode === 'zxjzhdb';
    },
    isZxjHhdbChannel() {
      return this.channelCode === 'zxjhhdb';
    },
    showInvoiceFields() {
      return !HIDDEN_INVOICE_CHANNELS.includes(this.channelCode);
    },
    showTabbedPartnerList() {
      return !SIMPLE_PARTNER_CHANNELS.includes(this.channelCode);
    },
    showBasicAccountFields() {
      return BASIC_ACCOUNT_CHANNELS.includes(this.channelCode);
    },
    showBasicAccountTip() {
      return !HIDDEN_BASIC_ACCOUNT_TIP_CHANNELS.includes(this.channelCode);
    },
    initBasicAccountFields() {
      return INIT_BASIC_ACCOUNT_CHANNELS.includes(this.channelCode);
    },
  },
  mounted() {
    this.code();
  },
  methods: {
    handleChane(e) {
      this.radioNum = e;
    },
    // 获取orderNo参数 调取已阅读接口
    getQueryString(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    init(val) {
      this.selectedPartnerCode = this.dataSourceInfo.partnerCode || '';
      this.form.setFieldsValue({
        invoiceType: this.dataSourceInfo.invoiceType,
        invoiceHead: this.dataSourceInfo.invoiceHead ? this.dataSourceInfo.invoiceHead : this.dataSourceInfo.basicAccountName,
        invoiceCuscCode: this.dataSourceInfo.invoiceCuscCode ? this.dataSourceInfo.invoiceCuscCode : this.dataSourceInfo.creditCode,
        invoiceEmail: this.dataSourceInfo.invoiceEmail,
        period: val ? this.dataSourceInfo.period : '',
        mobile: this.dataSourceInfo.mobile,
        partnerCode: this.dataSourceInfo.partnerCode,
        addInfo: this.dataSourceInfo.addInfo,
        bankInfo: this.dataSourceInfo.bankInfo,
        bankAcc: this.dataSourceInfo.bankAcc,
        addressee: this.dataSourceInfo.addressee,
        addresseePhone: this.dataSourceInfo.addresseePhone,
        address: this.dataSourceInfo.address,
        sectionCode: this.dataSourceInfo.sectionCode,
        tendereeName: this.dataSourceInfo.tendereeName,
        tendereeCreditCode: this.dataSourceInfo.tendereeCreditCode,
        sectionName: this.dataSourceInfo.sectionName,
        invitationCode: this.dataSourceInfo.invitationCode,
        responsiblePersonName: this.dataSourceInfo.responsiblePersonName,
        code: '0000',
      });
      if (this.initBasicAccountFields) {
        this.form.setFieldsValue({
          responsiblePersonName: this.dataSourceInfo.responsiblePersonName ? this.dataSourceInfo.responsiblePersonName : this.dataSourceInfo.principalName,
          basicAccountName: this.dataSourceInfo.basicAccountName,
          basicAccountNo: this.dataSourceInfo.basicAccountNo,
          basicAccountCode: this.dataSourceInfo.basicAccountCode,
        });
      }

      // activeIndex
      this.orderNo = this.getQueryString('orderNo');
      // 基本户银行获取
      if (this.showBasicAccountFields) {
        getLastAccount(this.orderNo).then(({ data: data }) => {
          if (data.data) {
            this.dataSourceInfo.basicAccountNo = data.data;
            this.form.setFieldsValue({
              basicAccountNo: this.dataSourceInfo.basicAccountNo,
            });
          }
        });
      }

      getChannelInfo({ orderNo: this.orderNo }).then(res => {
        this.readDocMap = res.data.readDocMap;
        this.timeArray = res.data.effectiveTime;
        this.form.setFieldsValue({
          period: this.dataSourceInfo.period ? this.dataSourceInfo.period : this.timeArray[0].value,
        });
      });
      getDictInfo('invoiceType').then(({ data: data }) => {
        this.typeArray = data.data;
      });
      getList({ orderNo: this.orderNo }).then(({ data: data }) => {
        this.logoArray = data.data;
        data.data.forEach(item => {
          if (item.partnerType === '1') {
            this.dbList.push(item);
          } else if (item.partnerType === '2') {
            this.bxList.push(item);
          } else if (item.partnerType === '3') {
            this.bankList.push(item);
          }
        });
        if (this.showTabbedPartnerList) {
          this.form.setFieldsValue({
            partnerCode: this.dbList[0].partnerCode,
          });
        } else {
          this.form.setFieldsValue({
            partnerCode: this.dbList[0].partnerCode,
          });
        }
        if (this.dataSourceInfo.channelCode === 'anqin') {

          data.data.forEach((item, index) => {
            if (item.partnerCode === 'ANQINGZDB') {
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.dataSourceInfo.channelCode === 'qianshan') {

          data.data.forEach((item, index) => {
            if (item.partnerCode === 'QIANSHANGZDB') {
              // 安徽潜山市交易中心-广泽担保的code
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.dataSourceInfo.channelCode === 'qianshanHuaShang') {

          data.data.forEach((item, index) => {
            if (item.partnerCode === 'QS_AHHSDB') {
              // 潜山交易中心-安徽华商担保的code
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.isHeilongjiangChannel) {
          // 华章汉辰
          data.data.forEach((item, index) => {
            if (item.partnerCode === 'HLJ_HZHC') {
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.isZxjHzhcChannel) {
          // 兵团阳光-华章汉辰
          data.data.forEach((item, index) => {
            if (item.partnerCode === 'ZXJ_HZHC') {
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.isZxjZhdbChannel) {
          // 兵团阳光-正泓担保
          data.data.forEach((item, index) => {
            if (item.partnerCode === 'ZXJ_ZHDB') {
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        if (this.isZxjHhdbChannel) {
          // 兵团阳光-瀚华担保
          data.data.forEach((item, index) => {
            if (item.partnerCode === 'ZXJ_HHDB') {
              this.handleClick(item);
              this.activeIndex = index;
            }
          });
        }
        // 未预置出函机构且无自动选中逻辑命中时，同步表单默认选中的出函机构
        if (!this.selectedPartnerCode) {
          this.selectedPartnerCode = this.form.getFieldValue('partnerCode') || '';
        }
      });
    },
    dbListClick(partnerCode) {
      this.selectedPartnerCode = partnerCode;
      this.form.setFieldsValue({
        partnerCode,
      });
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
      });
      this.orderNo = this.getQueryString('orderNo');
      getChannelInfo({ orderNo: this.orderNo }).then(res => {
        this.timeArray = res.data.effectiveTime;
      });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = '';
      if (
        this.form.instances.mobile.stateValue !== '' &&
        this.form.instances.code.stateValue !== ''
      ) {
        phoneCode({
          codeKey: this.uuid,
          code: this.form.instances.code.stateValue,
          phoneNum: this.form.instances.mobile.stateValue,
        }).then(({ data: data }) => {
          // console.log('---res',data);
          if (data.status === 200) {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning('手机号码和图形验证码不为空');
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },

    // 自定义校验
    basicAccountName(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入基本户户名');
      } else {
        callback();
      }
    },
    basicAccountNo(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入基本户银行账号');
      } else {
        callback();
      }
    },
    basicAccountCode(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入基本户统一社会信用代码');
      } else {
        callback();
      }
    },
    responsiblePersonName(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入经办人姓名');
      } else {
        callback();
      }
    },
    compareToFirstPhone(rule, value, callback) {
      const pattern = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback('请输入正确的手机号');
      }
    },
    compareToFirstCode(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入图形验证码');
      } else {
        callback();
      }
    },
    compareToFirstPhcode(rule, value, callback) {
      if (value === '' || !value) {
        callback('请输入短信验证码');
      } else {
        callback();
      }
    },

    getEmail(rule, value, callback) {
      const pattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback('请输入正确电子邮箱');
      }
    },

    // 点击选中
    handleClick(item) {
      if (this.dataSourceInfo.partnerCode) return;
      this.selectedPartnerCode = item.partnerCode;
      this.form.setFieldsValue({
        partnerCode: item.partnerCode,
      });
      this.logoArray.forEach(items => {
        items.isTrue = false;
      });
      this.$set(item, 'isTrue', !item.isTrue);
      this.$forceUpdate();
    },

    changeTab(changeTab) {
      console.log(changeTab);
      this.activeIndex = 0;
      if (changeTab === '3') {
        this.selectedPartnerCode = this.dbList[0].partnerCode;
        this.form.setFieldsValue({
          partnerCode: this.dbList[0].partnerCode,
        });
      }
      if (changeTab === '2') {
        this.selectedPartnerCode = this.bxList[0].partnerCode;
        this.form.setFieldsValue({
          partnerCode: this.bxList[0].partnerCode,
        });
      }
      if (changeTab === '1') {
        this.selectedPartnerCode = this.bankList[0].partnerCode;
        this.form.setFieldsValue({
          partnerCode: this.bankList[0].partnerCode,
        });
      }
    },

  },
};
</script>

<style lang="less" scoped>
.step1 {
  .img_logo {
    .img_list {
      display: flex;
      flex-wrap: wrap;
      .box {
        margin-right: 10px;
      }
    }
    #cur {
      cursor: no-drop;
    }
    #no {
      cursor: pointer;
    }
    #cur_i {
      border: 2px solid #1890ff;
    }
    .logo_box {
      width: 180px;
      height: 94px;
      border: 1px solid #8b8b8b;
      position: relative;
      img {
        width: 180px;
        height: 80px;
      }
      .suc {
        position: absolute;
        right: 3px;
        top: 3px;
        width: 16px;
        height: 16px;
      }
    }

    .money {
      font-size: 22px;
      color: #d9001b;
    }
  }

  /deep/ .ant-row {
    display: flex;
    margin-left: 15%;
    // justify-content: center;
  }

  .hrefa {
    // color: #666
    color: #1890ff;
  }

  .code {
    img {
      position: absolute;
      cursor: pointer;
      left: 185px;
      top: -6px;
      height: 28px;
    }

    a,
    span {
      position: absolute;
      width: 97px;
      left: 190px;
    }
  }
}

.palnList {
  display: flex;
  flex-wrap: wrap;

  .palnListBox {
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 425px;
    height: 80px;
    margin-bottom: 20px;
    position: relative;
    background: #ffffff;
    border: 2px solid #d2e1ec;
    border-radius: 4px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6a95b5;
    margin-right: 30px;
    cursor: pointer;
    // padding-left: 25px;
    transition: all 0.5s;

    .palnText {
      margin: 20px 0 0 17px;

      span {
        font-size: 16px;
        font-weight: bold;
      }

      p {
        font-size: 14px;
      }
    }

    img {
      // width: 330px;
      // height: 75px;
      height: 74px;
    }

    .feilv {
      position: absolute;
      text-align: center;
      top: -2px;
      right: -2px;
      width: 60px;
      height: 20px;
      background: #f83333;
      border-radius: 0px 4px 0px 10px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .palnListBoxAct {
    border: 2px solid #36a4ff;
    background: linear-gradient(-30deg, #e6f3fd 0%, #ffffff 100%);
    color: #007ce2;
    transition: all 0.5s;
  }
}

.content {
  margin-left: 15%;
}

.tit {
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
  margin: 30px 0 0px 157px;

  span {
    font-size: 14px;
    font-weight: 300;
    padding-left: 10px;
    color: black;
  }
}

::v-deep .ant-form-item-control {
  margin-left: 50px;
  width: 580px;
  word-wrap: break-word;
}

::v-deep .ant-form-item-label {
  text-align: left;
}

.items {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
  }

  ::v-deep .ant-col {
    height: 30px;
  }

  ::v-deep .ant-upload-list-item-card-actions .anticon {
    display: none;
  }
}

.items2 {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
    width: 260px;
  }

  ::v-deep .ant-col {
    height: 30px;
  }
}

.plastDialog2 {
  ::v-deep .ant-modal-footer {
    display: none;
  }
}

.formItem {
  ::v-deep .ant-form-item-label {
    padding-left: 11px;
  }
}

.requiredUpload {
  position: absolute;
  left: -280px;
  top: 13px;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
}

.sgin {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
::v-deep .hide {
  display: none !important;
}
.list {
  span {
    width: 185px;
    height: 80px;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    position: relative;
    cursor: pointer;
    img {
      width: 180px;
      height: 80px;
    }
    .suc {
      position: absolute;
      right: 3px;
      top: 3px;
      width: 16px;
      height: 16px;
    }
  }
  .dbSpan {
    width: 185px;
    border: 1px solid #8b8b8b;
    line-height: 80px;
    height: 80px;
    text-align: center;
    border-radius: 5px;
    font-weight: bold;
    .imgs {
      height: 80px;
      position: relative;
      top: -2px;
    }
  }
  .dbSpanhcjs{
    height: 136px;
    .imgs {
      height: 80px;
      position: relative;
      top: -2px;
    }
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
.list .tipA{
  width: 14px;
  height: 14px;
  background: linear-gradient( 270deg, #5DAEFF 0%, #0E52D4 100%);
  border-radius: 50%;
  transform: translateY(6px);
}
.tip {
  color: red;
  font-size: 12px;
  position: absolute;
  top: -10px;
  left: 290px;
  width: 300px;
}
.list .dbSpanhcjsP{
  width: 182px;
  height: 50px;
  background: #F0F6FF;
  border-radius: 0px 0px 4px 4px;
  margin:0!important;
  padding:0!important;
  display: block!important;
  padding-left: 5px!important;
}
.list .dbSpanhcjsPone{
  height: 25px;
  margin:0!important;
  display: block!important;
  padding:0!important;
  line-height: 25px!important;
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 11px;
  color: #666666;

}

</style>
